export default __webpack_public_path__ + "static/media/grafema_amcc_03.cd9f5569.jpg";